const utils = require('../../../lib/utils');
var selectNewValue;

module.exports = {
	config: {
		addNewElementsAllowed: false,
		nullAble: true,
		focusAble: true,
		scrollOffsetStart: 44,
		orientation: 'S',
		distanceY: '3px'
	},

	model: {
		open: false,
		dataJSON: []
		// values: {},
		// newValues: []
	},

	events: {
		click: function (event) {
			event.preventDefault();
			event.stopImmediatePropagation();
			var self = event.data.component;
			var $realTarget;
			var $target = $(event.target);

			if($target && $target.length > 0){
				if(($realTarget = $target.closest('button.unset')).length > 0){
					self.unChoose();
				}
				else if(($realTarget = $target.closest('button.add')).length > 0){
					self.addNewElement(self.model.$filterField.val());
				}
				else if(($realTarget = $target.closest('li')).length > 0 && $realTarget.closest('.optionList').length > 0){
					self.choose($realTarget.data('index'));
				}
				else if($target.closest('.optionList').length <= 0) {
					self.toggle();
				}
			}
		},

		change: function (event) {
			// prevent default change
			event.preventDefault();
			event.stopImmediatePropagation();
		},

		select: {
			type: 'keydown',
			action: function(event){
				var self = event.data.component;

				// close
				if(event.key === 'Escape'){
					event.preventDefault();
					event.stopImmediatePropagation();

					self.close();
				}
				else {
					var validKeyFound = true;

					// arrow down
					var $activeElement;
					if(event.key === 'ArrowDown'){
						$activeElement = self.model.$optionList.find('> li.active.selected:not(.disabled)').removeClass('selected');
						if($activeElement.length <= 0){
							$activeElement = self.model.$optionList.find('> li.active:not(.disabled)').first();
						}
						else {
							do { $activeElement = $activeElement.next(); } while($activeElement.length > 0 && (!$activeElement.hasClass('active') || $activeElement.hasClass('disabled')));
							if($activeElement.length <= 0) $activeElement = self.model.$optionList.find('> li.active:not(.disabled)').first();
						}
						$activeElement.addClass('selected');


						var offsetStart = self.model.$optionList.find('> li').first().position().top;
						var offset = $activeElement.position().top - offsetStart - self.config.scrollOffsetStart;
						if(offset > 0){
							self.model.$optionList.scrollTop(offset);
						}
						else {
							self.model.$optionList.scrollTop(0);
						}
					}
					else if(event.key === 'ArrowUp'){
						$activeElement = self.model.$optionList.find('> li.active.selected:not(.disabled)').removeClass('selected');
						if($activeElement.length <= 0){
							$activeElement = self.model.$optionList.find('> li.active:not(.disabled)').last();
						}
						else {
							do { $activeElement = $activeElement.prev(); } while($activeElement.length > 0 && (!$activeElement.hasClass('active') || $activeElement.hasClass('disabled')));
							if($activeElement.length <= 0) $activeElement = self.model.$optionList.find('> li.active:not(.disabled)').last();
						}
						$activeElement.addClass('selected');

						var offsetStart = self.model.$optionList.find('> li').first().position().top;
						var offset = $activeElement.position().top - offsetStart - self.config.scrollOffsetStart;
						if(offset > 0){
							self.model.$optionList.scrollTop(offset);
						}
						else {
							self.model.$optionList.scrollTop(0);
						}
					}
					else if(event.key === 'Enter'){
						var $target;
						if(($activeElement = self.model.$optionList.find('> li.active.selected:not(.disabled)')).length > 0){
							self.choose($activeElement.data('index'));
						}
						else if(($target = $(event.target).closest('input')).length > 0){
							var $existingElement = false;
							var filterValue = $target.val();
							self.model.$optionList.find('> li').each(function(index){
								if($(this).text() == filterValue){
									$existingElement = $(this);
									return false;
								}
							});

							// existing element
							if($existingElement){
								self.choose($existingElement.data('index'));
							}
							// new element
							else if(filterValue) {
								self.addNewElement(filterValue);
							}
						}
					}
					else {
						validKeyFound = false;
					}

					if(validKeyFound){
						event.preventDefault();
						event.stopImmediatePropagation();
					}
				}
			}
		},

		filter: {
			type: 'input',
			selector: 'input',
			action: function(event){
				event.data.component.filter(event.target.value);
			}
		},

		close: {
			type: 'focusout',
			action: function (event) {
				var self = event.data.component;
				var $focusTarget;

				if(
					self.model.open &&
					($focusTarget = $(event.relatedTarget)).length > 0 &&
					self.$.has($focusTarget).length <= 0 &&
					!self.$.is($focusTarget)
				){
					self.close();
				}
			}
		},
	},

	methods: {

		prepare: function(storage, isServer){
			var self = this;
			var maxOptionsIndex;

			self.model.disabled = false;
			self.model.isFilterField = false;
			if((self.formMapping || {}).fieldConfig) {
				self.model.disabled = !!self.formMapping.fieldConfig.disabled;
				self.model.isFilterField = !!self.formMapping.fieldConfig.isFilterField;
			}

			// prepare config
			self.model.config = self.model.config || {};
			self.model.disabled |= self.model.config.disabled;
			if(self.model.config.orientation) self.config.orientation = self.model.config.orientation;
			if(self.model.config.addNewElementsAllowed) self.config.addNewElementsAllowed = self.model.config.addNewElementsAllowed;
			if(self.model.config.nullAble !== undefined) self.config.nullAble = self.model.config.nullAble;
			var renderConfig = self.model.config.renderConfig || {};
			var groupConfig = renderConfig.groupEntries || {};
			groupConfig = utils.replace({ children: 'children', valuePrefix: '' }, groupConfig);
			var childConfig = renderConfig.optionEntries || {};
			childConfig = utils.replace({ value: 'value', name: 'name', title: 'title' }, childConfig);

			// prepare user-lang
			var langCode;
			if((((window.storage || {}).user || {}).data || {}).langCode){
				langCode = window.storage.user.data.langCode;
			}

			// prepare relation config
			var isRelationField;
			var relationConfig;
			if(!!self.model.config && !!self.model.config.relationConfig){
				isRelationField = true;
				relationConfig = self.model.config.relationConfig;
			}

			// prepare source-data-flag
			var dataAttributeKey;
			if(!!self.model.atom && !!self.model.atom.dataType){
				dataAttributeKey = self.model.atom.dataType + '-data';
			} else {
				dataAttributeKey = 'data';
			}

			// prepare options
			self.model.options = undefined;
			if(Array.isArray(self.model[dataAttributeKey])){
				self.model.options = self.model[dataAttributeKey];
			}
			else if(!!self.model[dataAttributeKey] && !!self.model[dataAttributeKey].options){
				self.model.options = self.model[dataAttributeKey].options;
			}

			// prepare default entry
			if(renderConfig.defaultOptionEntry){
				var entry = {};
				if(langCode && renderConfig.defaultOptionEntry.lang && renderConfig.defaultOptionEntry.lang[langCode]){
					entry[childConfig.name] = renderConfig.defaultOptionEntry.lang[langCode];
					entry[childConfig.title] = renderConfig.defaultOptionEntry.lang[langCode];
					entry[childConfig.value] = renderConfig.defaultOptionEntry.value;
				}
				else {
					entry[childConfig.name] = renderConfig.defaultOptionEntry.name;
					entry[childConfig.title] = renderConfig.defaultOptionEntry.title || entry[childConfig.name];
					entry[childConfig.value] = renderConfig.defaultOptionEntry.value;
				}
				self.model.options.unshift(entry);
			}

			if(self.model.options){
				// console.log('PREPARE OPTION', self.model.selectNewValue, self.model.options);

				var optionConfig = childConfig;
				var selectedOptionIndex;
				var defaultSelectedOptionIndex;
				var testValue;
				utils.map(self.model.options, function(option, optionIndex){
					maxOptionsIndex = optionIndex;

					// define option name and title
					var optionName, optionTitle;
					if(!!option.lang && !!langCode && !!option.lang[langCode] && !!option.lang[langCode][optionConfig.name]){
						optionName = option.lang[langCode][optionConfig.name];
					} else if (!!option[optionConfig.name]) {
						optionName = option[optionConfig.name];
					} else {
						optionName = '-NO-NAME-FOUND-';
					}
					if(!!option.lang && !!langCode && !!option.lang[langCode] && !!option.lang[langCode][optionConfig.title]){
						optionTitle = option.lang[langCode][optionConfig.title];
					} else if (!!option[optionConfig.title]) {
						optionTitle = option[optionConfig.title];
					} else {
						optionTitle = optionName;
					}

					// define if option is selected
					var optionSelected = false;
					var relationDataIndex;
					if(isRelationField){
						if(Array.isArray(self.model.dataJSON)){
							for(relationDataIndex in self.model.dataJSON){
								if(self.model.dataJSON[relationDataIndex].attributes[relationConfig.assignedPrimaryKey] == option[optionConfig.value]){
									optionSelected = true;
									break;
								}
							}
						}
					}
					else if(Array.isArray(self.model.dataJSON)){
						optionSelected = utils.indexOf(self.model.dataJSON, option.value) >= 0;
					} else if(self.model.dataTEXT != undefined && self.model.atom.dataType === 'template-picker'){
						optionSelected = option[optionConfig.value] == self.model.dataTEXT;
					} else {
						optionSelected = !!option.defaultSelected;
					}

					// option.selected = optionSelected;
					if(optionSelected){
						selectedOptionIndex = optionIndex;
					}
					option.relationDataIndex = relationDataIndex;
					option.realName = optionName;
					option.realTitle = optionTitle;
					option.realValue = option[optionConfig.value];

					if(self.model.config.defaultValue){
						testValue = option.realValue;
						if(self.model.config.defaultValueField){
							testValue = ((option.resource || {}).attributes || {})[self.model.config.defaultValueField];
						}
						if(testValue == self.model.config.defaultValue){
							defaultSelectedOptionIndex = optionIndex;
						}
					}

					return option;
				});

				if(selectedOptionIndex){
					self.model.options[selectedOptionIndex].selected = true;
					self.model.selectedOption = self.model.options[selectedOptionIndex];
				} else if(defaultSelectedOptionIndex) {
					self.model.options[defaultSelectedOptionIndex].selected = true;
					self.model.selectedOption = self.model.options[defaultSelectedOptionIndex];
					if(!isServer){
						self.triggerClosest('onChildChanged', {
							fieldCode: 	self.model.fieldCode,
							value: 		self.model.selectedOption.realValue
						});
					}
				}
			}
		},

		open: function(){
			this.$.addClass('active');
			this.model.open = true;
			this.model.$filterField.focus();
			this.model.$buttonOpen.find('i').removeClass('fi-arrow-circle-down').addClass('fi-arrow-circle-up')
		},
		close: function(){
			this.$.removeClass('active');
			this.model.open = false;
			this.model.$buttonOpen.find('i').removeClass('fi-arrow-circle-up').addClass('fi-arrow-circle-down')
		},
		toggle: function(){
			if(this.model.open) this.close();
			else 				this.open();

		},
		choose: function(index){
			var option = {};
			if(this.model.options[index]){
				option = this.model.options[index];
				this.model.selectedOption = this.model.options[index];
			}
			this.model.$value.html(option.realName).attr('title', option.realTitle);
			this.model.$optionList.find('.selected').removeClass('selected');
			this.model.$optionList.find('[data-index="' + index + '"]').addClass('selected');
			if(utils.isFunction(this.onChoose)){
				this.onChoose({
					fieldCode: 	this.model.fieldCode,
					value: 		option.realValue
				});
			} else {
				this.triggerClosest('onChildChanged', {
					fieldCode: 	this.model.fieldCode,
					value: 		option.realValue
				});
			}

			this.close();
		},
		unChoose: function(){
			if(
				this.config.nullAble
				&&
				(
					!utils.isEmpty(this.model.dataJSON)
					||
					this.model.selectedOption
				)
			){
				this.model.$value.html('&nbsp;').attr('title', '');
				this.model.$optionList.find('.selected').removeClass('selected');
				this.model.dataJSON = [];
				if(this.model.selectedOption){
					this.model.selectedOption.selected = false;
				}
				delete this.model.selectedOption;
				if(utils.isFunction(this.onChoose)){
					this.onChoose({
						fieldCode: 	this.model.fieldCode,
						value: 		null
					});
				} else {
					this.triggerClosest('onChildChanged', {
						fieldCode: 	this.model.fieldCode,
						value: 		null
					});
				}
				this.close();
			}
		},
		enable: function(){
			if(this.model.disabled){
				this.model.disabled = false;
				this.refresh(false);
			}
		},
		disable: function(){
			if(!this.model.disabled){
				this.model.disabled = true;
				this.refresh(false);
			}
		},
		filter: function(filterValue){
			var regExp = new RegExp(filterValue, 'i');
			var $element, value;
			var self = this;
			if(!filterValue && filterValue !== 0){
				self.model.$optionList.find('> li').addClass('active');
			} else {
				self.model.$optionList.find('> li').each(function(index){
					$element    = $(this);
					value       = $element.text();

					if(value == '' || value.match(regExp)){
						$element.addClass('active');
					}
					else {
						$element.removeClass('active');
					}
				});
			}
		},

		addNewElement: function(value){
			// NOTE: OVERWRITE THIS FUNCTION IF NEEDED
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;

			this.parent(function(parentComponent){
				self.model.parentComponent = parentComponent;
			});
			this.model.$optionListContainer = $element.find('.optionList');
			this.model.$main = $element.find('.main');
			this.model.mainHeight = this.model.$main.outerHeight();
			this.model.$filterField = this.model.$optionListContainer.find('input');
			this.model.$optionList = this.model.$optionListContainer.find('> ul');
			this.model.$value = $element.find('.value');
			this.model.$buttonOpen = $element.find('button.open');

			// init filter
			var value = this.model.$filterField.val();
			this.filter(value);

			// set position if necessary
			if(this.config.orientation === 'N'){
				this.model.$optionListContainer.css('margin-top', 'calc(-' + this.config.distanceY + ' - ' + (this.model.mainHeight || 0) + 'px)');
			} else {
				this.model.$optionListContainer.css('margin-top', this.config.distanceY);
			}
		}
	}
};
